import ReaganRonaldEmbed from "../images/ReaganRonaldEmbed";
import Reagan from "../Thumbs/Reagan60.jpg";

const ReaganRonald = {
    objectName: 'ReaganRonald',
    firstName: 'Ronald',
    lastName: 'Reagan',
    dates: '1911-2004',
    id: 'RR19112004',
    image: ReaganRonaldEmbed,
    thumbImg: Reagan,
    quotes: [
    {
        tabHeading: `We Need God More Than He Needs Us`,
        metaDescription: `President Ronald Reagan's "We Need God MORE than He Needs Us" Speech`,
        keywords: ["TrueLibertyNorth", ],
        title: 'We Need God More Than He Needs Us',
        id: 'PRRweNeedGodSpch',
        date: '',
        headTitle: `Ronald Reagan - We Need God More Than He Needs Us`,
        headDescription: `President Reagan's Need for God Speech`,
        content: [
              {normal: `I’ve always believed that we were put here for a reason, that there is a path, somehow a divine plan for all of us and for each one of us. 
            And I’ve also always believed that America was set apart in a special way, that it was put here between the oceans to be found by a certain kind of people, 
            based on a quality that these people had but that they came from every corner of the world. And a country then was created by men and women who came, not 
            for gold, but mainly in search of God. They would be free people, living under the Law with faith in their Maker and in their future.`},
            {normal: `It’s been written that the most sublime figure in American History was George Washington, on his knees in the snow at Valley Forge. He personified 
            a people who knew that it was not enough to depend on their own courage and goodness; that they must also seek help from God, their Father, and Preserver.`},
            {normal: `Where did we begin to lose sight of that noble beginning; of our conviction that standards of right and wrong do exist and must be lived up to?`, 
              bold2: ` Do we really think that we can have it both ways; that God will protect us in a time of crisis even as we turn away from Him in our day to day life?`},
            {normal: `It’s time to realize I think that, we need God more than He needs us.`}
        ],
        considerations: [
            {
                name: '',
                title: 'Ronald Reagan',
                date: '',
                content: [`If we ever forget that we are one nation under God, then we will be a nation gone under.`]
            },
            {
              name: '',
              title: 'Thomas Jefferson',
              date: '',
              content: [`God who gave us life gave us liberty. And can the liberties of a nation be thought secure when we have removed their only firm basis, a 
            conviction in the minds of the people that these liberties are of the Gift of God? That they are not to be violated but with His wrath? Indeed, I 
            tremble for my country when I reflect that God is just; that His justice cannot sleep forever; That a revolution of the wheel of fortune, a change of 
            situation, is among possible events; that it may become probable by Supernatural influence! The Almighty has no attribute which can take side with us 
            in that event.`]
          }
        ]
    }    
]};

export default ReaganRonald;